import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone } from 'lucide-react';
import { PHONE_NUMBER } from '../../utils/constants';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [cityOpen, setCityOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const dropRef = useRef();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); setCityOpen(false); }, [location]);

  useEffect(() => {
    const h = (e) => { if (dropRef.current && !dropRef.current.contains(e.target)) setCityOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const solid = scrolled || !isHome;

  return (
    <>
      <nav className={"navbar " + (solid ? 'navbar--solid' : 'navbar--transparent')}>
        <div className="navbar__inner container-wide">
          <Link to="/" className="navbar__logo">
            <img src="/logo.png" alt="Smart Property Solutions" />
          </Link>
          <ul className="navbar__links">
            <li><NavLink to="/" end>Home</NavLink></li>
            <li><NavLink to="/about">About Us</NavLink></li>
            <li><NavLink to="/properties">Properties</NavLink></li>
            <li className="has-dropdown" ref={dropRef}>
              <button className="dropdown-trigger" onClick={() => setCityOpen(p => !p)}>
                Cities <ChevronDown size={13}/>
              </button>
              {cityOpen && (
                <ul className="dropdown">
                  <li><Link to="/cities/delhi-ncr">Delhi NCR</Link></li>
                  <li><Link to="/cities/dholera-sir">Dholera SIR</Link></li>
                  <li><Link to="/cities/ahmedabad">Ahmedabad</Link></li>
                </ul>
              )}
            </li>
            <li><NavLink to="/partnership">Partnership</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
          </ul>
          <div className="navbar__actions">
            <a href={"tel:" + PHONE_NUMBER} className="navbar__phone">
              <Phone size={14}/> {PHONE_NUMBER}
            </a>
            <Link to="/contact" className="btn-primary navbar__cta">Enquire Now</Link>
          </div>
          <button className="navbar__hamburger" onClick={() => setMenuOpen(p => !p)}>
            {menuOpen ? <X size={22}/> : <Menu size={22}/>}
          </button>
        </div>
      </nav>
      <div className={"navbar__mobile " + (menuOpen ? 'open' : '')}>
        <ul>
          <li><NavLink to="/" end>Home</NavLink></li>
          <li><NavLink to="/about">About Us</NavLink></li>
          <li><NavLink to="/properties">Properties</NavLink></li>
          <li className="mobile-city-label">Cities</li>
          <li className="mobile-city-link"><NavLink to="/cities/delhi-ncr">Delhi NCR</NavLink></li>
          <li className="mobile-city-link"><NavLink to="/cities/dholera-sir">Dholera SIR</NavLink></li>
          <li className="mobile-city-link"><NavLink to="/cities/ahmedabad">Ahmedabad</NavLink></li>
          <li><NavLink to="/partnership">Partnership</NavLink></li>
          <li><NavLink to="/contact">Contact</NavLink></li>
        </ul>
        <div className="mobile-actions">
          <a href={"tel:" + PHONE_NUMBER} className="mobile-call"><Phone size={14}/> {PHONE_NUMBER}</a>
        </div>
      </div>
    </>
  );
};

export default Navbar;
